/* Reuse the space below Related; its caption ends at the purchase bar. */
(() => {
  let frame=0;
  function fit() {
    frame=0;
    if (!matchMedia('(min-width:1201px)').matches) return;
    const section=document.querySelector('section.ak-session-6');
    const relatedGrid=section?.querySelector('.ak-session-6__grid');
    if (relatedGrid) {
      const count=relatedGrid.querySelectorAll('.ak-session-6__card:not([hidden])').length;
      if (relatedGrid.dataset.akRelatedCount!==String(count)) relatedGrid.dataset.akRelatedCount=String(count);
    }
    const rail=document.querySelector('.ak-site-frame-rail--left .ak-site-frame-rail__grid--bottom');
    const purchase=document.querySelector('.ak-flow-purchase');
    if (!section || !rail || !purchase) return;
    // Measure layout sizes: the intro animation can temporarily translate
    // the purchase bar and make viewport positions report a taller caption.
    const height=rail.offsetHeight-purchase.offsetHeight;
    if (height>0 && section.style.getPropertyValue('--ak-related-caption-height')!==height+'px') {
      section.style.setProperty('--ak-related-caption-height',height+'px');
    }
  }
  function schedule() { if (!frame) frame=requestAnimationFrame(fit); }
  function init() {
    schedule();
    const grid=document.querySelector('section.ak-session-6 .ak-session-6__grid');
    if (grid) new MutationObserver(schedule).observe(grid,{subtree:true,attributes:true,attributeFilter:['hidden','class']});
    const observer=new ResizeObserver(schedule);
    document.querySelectorAll('.ak-site-frame-rail--left .ak-site-frame-rail__grid--bottom, .ak-flow-purchase').forEach(element=>observer.observe(element));
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  ['resize','load','ak:boot-revealed','ak:global-frame-ready','ak:mobile-resume','ak-related-geometry-synced'].forEach(name=>window.addEventListener(name,schedule));
})();
